<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const sections = [
  { key: 'PHONE_TARIFF', icon: 'i-lucide-phone' },
  { key: 'HOSTING_REPORT', icon: 'i-lucide-file-text' },
  { key: 'SETTINGS', icon: 'i-lucide-settings' },
];
</script>

<template>
  <div class="flex flex-col gap-4">
    <div>
      <h3 class="text-base font-medium text-slate-800 dark:text-slate-100">
        {{ t('TDF.OTHER_ROUTINES.HEADER') }}
      </h3>
      <p class="text-sm text-slate-600 dark:text-slate-300">
        {{ t('TDF.OTHER_ROUTINES.DESCRIPTION') }}
      </p>
    </div>

    <div class="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
      <div
        v-for="section in sections"
        :key="section.key"
        class="flex items-center gap-4 rounded-lg border border-slate-200 bg-white p-4 transition-shadow hover:shadow-sm dark:border-slate-600 dark:bg-slate-800"
      >
        <span class="size-10 text-blue-500" :class="section.icon" />
        <div class="flex flex-col">
          <span class="text-sm font-medium text-slate-800 dark:text-slate-100">
            {{ t(`TDF.OTHER_ROUTINES.${section.key}`) }}
          </span>
          <span class="text-xs text-slate-500">
            {{ t('TDF.COMMON.COMING_SOON') }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
